import Purchases from "../../views/modules/purchases/Purchases";
import DocumentList from "../../views/modules/purchases/documents/DocumentList";
import OrderBuyP from "../../views/modules/projects/OrderBuyP";
import InventoryIntemp from "../../views/modules/projects/InventoryIntemp";
import MaintenanceCalendarP from "../../views/apps/calendar/CalendarMaintenanceNotBreadcrumb";
import Providers from "../../views/modules/projects/Providerlist";
// import OrderList from "../../views/modules/purchases/orders/OrderList";
// import InventoryList from "../../views/modules/purchases/inventory/InventoryList";
// import technicalSupport_inventoryList from "../../views/modules/purchases/technicalSupport_inventory/technicalSupport_inventoryList";
// import WarehouseInventoryList from "../../views/modules/purchases/warehouse_inventory/WarehouseInventoryList";
// import FixedAssetList from "../../views/modules/purchases/fixed_assets/FixedAssetList";

// // reports

import layouts from "../../layout";
//import store from "@/store";
//import { COMPANYS } from "@/const";

export default {
  path: "/purchases",
  name: "purchases",
  component: Purchases,
  meta: {
    auth: true
  },
  redirect: {
    name: "purchases-order"
  },
  children: [
    {
      path: "orders",
      name: "purchases-order",
      component: OrderBuyP,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Orders",
        tags: ["purchases", "orders"],
        index: true
      }
    },
    {
      path: "Provider",
      name: "purchases-provider",
      component: Providers,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Proveedores",
        tags: ["purchases", "provider"],
        index: true
      }
    },
    {
      path: "inventory",
      name: "purchases-inventory",
      component: InventoryIntemp,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Inventory",
        tags: ["purchases", "inventory"],
        index: true
      }
    },
    // {
    //   path: "warehouse_inventory",
    //   name: "purchases-warehouse-inventory",
    //   component: WarehouseInventoryList,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Warehouse Inventory",
    //     tags: ["purchases", "warehouseInventory"],
    //     index: true
    //   }
    // },
    // {
    //   path: "technicalSupport_inventory",
    //   name: "purchases-inventory-Support",
    //   component: technicalSupport_inventoryList,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Inventory Technical Support ",
    //     tags: ["purchases", "inventorySupport"],
    //     index: true,
    //     disable: store.state.user.user.CompanySelected !== COMPANYS.TB
    //   }
    // },
    // {
    //   path: "fixed_assets",
    //   name: "purchases-fixed-asset",
    //   component: FixedAssetList,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Fixed Assets",
    //     tags: ["purchases", "fixedAsset"],
    //     index: true
    //   }
    // },

    {
      path: "MaintenanCalendar",
      name: "purchases-calendarM",
      component: MaintenanceCalendarP,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Agenda de Mantenimiento",
        tags: ["finances", "genda de Mantenimiento"],
        index: true
      }
    },
    {
      path: "documents",
      name: "purchases-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["finances", "documents"],
        index: true
      }
    }
  ]
};
